module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_8004.39cf618c.png";